import { Link } from "react-router-dom";
import { Button } from '@chakra-ui/react';
import '../App.css'

const BoxOne = () => {
    return (
        <div className="App">
            <div className="App-body">
                <h1>Overview</h1>
                <p>
                You’ve always known the corporate world of Globex Corporation was a harsh and unforgiving place, but lately, things have taken 
                a darker turn. As a dedicated employee, you’ve endured the endless meetings, cryptic emails, and grueling performance reviews. 
                But nothing prepared you for the sudden disappearance of your best friend and closest confidant at work, Nina. <br/><br/>
                
                For days now, Nina has been uncharacteristically absent. No texts, no calls, no emails. It’s as though she vanished without a trace. 
                The worry gnaws at you, and you can’t shake the feeling that something is terribly wrong.
                </p>
                <Button as={Link} to='/BoxOne' bg="#7c55d2" color="white" _hover={{bg:"#5a3cb0"}}>Continue</Button>
            </div>
        </div>
    );
  };
  
export default BoxOne;
  